
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ResendInvitationWrapper extends Vue {
	invitationResent = false;

	setInvitationSentStatus(): void {
		this.invitationResent = true;
	}
}
